/*  THIS FUNCTION SENDS A PING / MAKES AN AJAX CALL TO THE SERVER */

// HOW OFTEN SHOULD A VSITOR SEND A PING / SILENTLY CONTACT SMETIO SERVER
// THIS IS NEEDED FOR CHECKING WHEN A USER HAS NAVIGATED FROM A PAGE AND ALSO FOR MITIGATING SESSION HIJACKING ATTACK AS THE PHSSID WILL BE REGNERATED DURING EVERY PING

function smetio_ping(){
	
	const SMETIO_KEEP_ALIVE_CONN = new Smetio_AjaxServerConnection("https://smetio.com/ping/ping.php");
	
	// LOCATION WILL STILL BE OBTAINED IF PERMISSION HAS ALREADY BEEN GIVEN

	SMETIO_KEEP_ALIVE_CONN.locationIsRequired = false;

	// CONNECTION SHOULD NOT BE COUNTED
	SMETIO_KEEP_ALIVE_CONN.countThisConnection = false;
	
	// THE USER DOES NOT NEED TO KNOW THAT THIS CONNECTION IS GOING ON

	SMETIO_KEEP_ALIVE_CONN.showTheUserThatThereIsAnOngoingConnection = SMETIO_NO;
	
	SMETIO_KEEP_ALIVE_CONN.onConnectionIsSuccessful = function(result){
		
		console.log(result);
	
	};

	SMETIO_KEEP_ALIVE_CONN.onConnectionEndedWithAnError = function(request, status, error){
		
		console.log(error);
		
	};
	
	// MAKE THE CONNECTION
	
	SMETIO_KEEP_ALIVE_CONN.connect();
	
};

/* 
 * CREATE A WEB WORKER THAT WILL BE USED TO TRIGGER THE PING USING THE INTERVAL THAT IS SENT TO IT
 * 
 * */

function startPing(){
	
	// CHECK THAT WEB WORKER IS SUPPORTED BY THE USERS BROWSER
	
	let w;
	
	if(typeof(Worker) !== "undefined"){
		
		// CHECK IF THE WEB WORKER HAD ALREADY BEEN CREATED
		
		if(typeof(w) == "undefined"){
			
			console.log("WEB WORKER HAS STARTED");
			
			// CREATE THE WEB WORKER INSTANCE WITH THE PING URL
			
			w = new Worker(SMETIO_PING_ENDPOINT+"?h=ghvjhgiffdgglkjhdssdsfghjkfhjdkhgf");
			
		};
		
		// SEND THE PING INTERVAL TO THE WEB WORKER
		
		w.postMessage({ message : SMETIO_PING_INTERVAL_LIMIT});
		
		// CALL THE PING FUNCTION WHEN A MESSAGE IS RECIEVED FROM THE WEB WORKER
		// THE WEB WORKER WILL CONTINUE TO SEND MESSAGE USING THE SMETIO_PING_INTERVAL_LIMIT
		
		w.addEventListener("message", function(event){

			smetio_ping();
			
		});	
		
		smetio_isWebWorkerSupported = true;
		
	}else{
	
		// WEB WORKER NOT SUPPORTED
		
		smetio_isWebWorkerSupported = false;
		
	};
	

};

startPing();














